import React, { useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Input} from "@nextui-org/react";
import { RxUpdate } from "react-icons/rx";
import axios from "axios";
import { toast } from "react-toastify";
import { FiEdit } from "react-icons/fi";
import { orders_uri } from "../../../utils/url";

export default function UpdateModal({data, callback}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [pay, setPay] = useState();
  const [load, setLoad] = useState(false);

//   const [phone, setPhone] = useState(data.phone_or_depo);
//   const [too, setToo] = useState(data.too);
  const [code, setCode] = useState(data.code);

  const call = () =>{
    callback();
  }
  
  const Sub = async()=>{
    setLoad(true);
    try{
        const res = await axios.patch(orders_uri+'/code', {id: data.id,code:code});
        if(res.status === 200){
            toast.success("Амжилттай");
            setPay('');
            call();
            setLoad(false);
            onOpenChange(false);
        }
    }catch(err){
        console.log(err);
        setLoad(false);
    }
  }



  return (
    <>
      <FiEdit  onClick={onOpen} className="bg-gray-400 rounded-full p-1 cursor-pointer" color="white" size={24}/>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Захиалга засварлах</ModalHeader>
              <ModalBody>
                <div className="font-Roboto">
                    <h1 className="text-sm font-bold">Код *</h1>
                    <Input className="mt-2" size="sm" value={code} onChange={(e)=> setCode(e.target.value)}/>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Close
                </Button>
                {
                    load?
                    <Button className="bg-blue-300">
                        Засварлаж байна ...
                    </Button>
                    :
                    <Button color="primary" onPress={Sub}>
                        Тийм
                    </Button>
                }
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
